import React, { useEffect, useState, useRef } from 'react';
import {
    Row, Col, Button, Card, ProTableOt, useProTableOt, setParamsFilter, Input, Form, AspectRatio,
    Accordion, AccordionItem, AccordionTrigger, AccordionContent, Tabs,
    Typography
} from '../../ui/ot'
import { useSearchParams, useNavigate } from "react-router-dom";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import AdvancedSearchForm from './advanced_search_form'
import useWindowSize from '../controllers/window_size';
import { useBib } from '../../koha/controllers/bib_controller';

import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "../../ui/select";
import dayjs from 'dayjs';
import { useTranslation } from "react-i18next";

function SearchFunction({
    propsNavigateCollectionSearchPath = "/online_public_catalog_query_construction/collection_search",
    keyPrefix = "library.online_public_catalog_query_construction.collection_search"
}) {
    const navigate = useNavigate();
    const { t } = useTranslation('translation', { keyPrefix })

    const [advancedSearch, setAdvancedSearch] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();
    const { width, height } = useWindowSize();
    const [tableSearchParams, setTableSearchParams] = useState({
        branchcode_arr: [],
        ...Object.fromEntries(searchParams.entries())
    });
    console.log({
        ...Object.fromEntries(searchParams.entries())
    })
    const [showMode, setShowMode] = useState("cardPage")
    const styles = {
        searchContainer: {
            margin: '20px',
            justifyContent: 'center',
            alignItems: 'center',
        },
        selectStyle: {
            backgroundColor: 'white',
            border: '2px solid #2f7c9d',
            color: '#2f7c9d',
            borderRadius: '50px',
            width: '100%',
            textAlign: 'center',
            padding: '5px',
        },
        searchInput: {
            borderRadius: '50px',
            border: '2px solid #2f7c9d',
            padding: '5px 20px',
            width: '100%',
        },
        searchButton: {
            backgroundColor: '#f28d35',
            border: 'none',
            borderRadius: '50px',
            padding: '5px 20px',
            color: 'white',
            width: '100%',
        },
        informationButton: {
            backgroundColor: '#f28d35',
            border: 'none',
            borderRadius: '50px',
            padding: '5px 20px',
            color: 'white',
            width: '20%',
        },
        cardStyle: {
            marginTop: '20px',
            border: '1px solid #eaeaea',
            borderRadius: '10px',
            padding: '15px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        },
        titleStyle: {
            fontSize: '1.2rem', // 調整字體大小
            fontWeight: 'bold', // 設置粗體
        },
        imageStyle: {
            width: 'auto',
            // height: 'auto',
            height: "14em",
            // width: "14em",
        },
        paginationButton: {
            margin: '5px',
            padding: '5px 10px',
            border: '1px solid #2f7c9d',
            borderRadius: '5px',
            cursor: 'pointer',
        },
        disabledButton: {
            margin: '5px',
            padding: '5px 10px',
            border: '1px solid #ccc',
            borderRadius: '5px',
            cursor: 'not-allowed',
            color: '#ccc',
        },
        activeButton: {
            backgroundColor: '#2f7c9d',
            color: 'white',
            border: '2px solid #2f7c9d',
            borderRadius: '20px',
            width: '100%',
            margin: '5px 0',
        },
        inactiveButton: {
            backgroundColor: 'white',
            color: '#2f7c9d',
            border: '2px solid #2f7c9d',
            borderRadius: '20px',
            width: '100%',
            margin: '5px 0',
        },
        sectionTitle: {
            fontSize: '18px',
            fontWeight: 'bold',
        },
        buttonGroup: {
            margin: '5px 0',
        }
    };
    const [advanced_search_form] = Form.useForm(); //form 
    const [form] = Form.useForm(); //form 

    const actionRef = useRef(null); //要呼叫ProTableOt 的 function 所需要的，想知道原理請去查詢 forwardRef, useImperativeHandle, 
    const columns = [
        {
            title: `${t('bib_title')}`,
            dataIndex: "bib_title",
            key: "bib_title",
            width: "400px"
        },
        {
            title: `${t('import_bibliography_date')}`,
            dataIndex: "bib_datecreated",
            key: "bib_datecreated",
        },
        {
            title: `${t('Author')}`,
            dataIndex: "bib_author",
            key: "bib_author",
        },
        {
            title: `${t('bib_translator')}`,
            dataIndex: "bib_translator",
            key: "bib_translator",
        },

        {
            title: `${t('Material_type')}`,
            dataIndex: "bib_materialType",
            key: "bib_materialType",
        },
        {
            title: `${t('Series')}`,
            dataIndex: "bib_seriestitle",
            key: "bib_seriestitle",
            render: (text, record, index) => {
                return <>{record?.bib_seriestitle} {record?.bibitem_volume}</>
            }
        },
        {
            title: `${t('Publication_details')}`,
            dataIndex: "bib_publisher",
            key: "bib_publisher",
        },
        {
            title: `${t('Description')}`,
            dataIndex: "bib_notes",
            key: "bib_notes",
        },
        {
            title: `${t('ISBN')}`,
            dataIndex: "bibitem_isbn",
            key: "bibitem_isbn",
        },
        {
            title: `${t('Edition')}`,
            dataIndex: "bibitem_editionstatement",
            key: "bibitem_editionstatement",
        },
        {
            title: `${t('Other_title')}`,
            dataIndex: "bib_othertitle",
            key: "bib_othertitle",
            render: (text, record, index) => {
                return <>{text?.join('、')}</>
            }
        },

    ];


    const [selectedCollection, setSelectedCollection] = useState('館藏區1'); // 館藏區選擇
    const [selectedBookType, setSelectedBookType] = useState('電子書'); // 藏書種類
    const [selectedYear, setSelectedYear] = useState('2024'); // 出版年選擇

    const handleCollectionClick = (value) => {
        setTableSearchParams((pre) => {
            let preBranchcodeArr = [...pre?.branchcode_arr]
            if (preBranchcodeArr.includes(value)) {
                preBranchcodeArr = preBranchcodeArr.filter((ele) => ele !== value)
                return {
                    ...pre,
                    branchcode_arr: [...preBranchcodeArr]
                }
            }
            else {
                return {
                    ...pre,
                    branchcode_arr: [...preBranchcodeArr, value]
                }
            }

        })
    };

    const handleBookTypeClick = (type) => {
        setSelectedBookType(type);
    };

    const handleYearClick = (year) => {
        setSelectedYear(year);
    };
    const onSubmit = (values) => {
        console.log({
            values
        })
        setTableSearchParams((pre) => {
            return {
                keyword: values?.keyword,
                field: values?.field,
                branchcode_arr: pre?.branchcode_arr,
            }
        })
        // navigate(`${propsNavigateSearchPath}?` + new URLSearchParams(values));
    };

    const bibController = useCRUDController({
        apiRoute: "/koha/bib",
    })
    const libraryController = useCRUDController({
        apiRoute: "/koha/library",
        // onBefore: ()=>{},
        // onFinish: onFinish,
    })
    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useProTableOt({
            columns,
        });
    const {
        BibData,
        getBibData,
        getBibInfoFormat
    } = useBib({
        onFinish: () => { },
        onBefore: () => { }
    })
    useEffect(() => {
        checkAll();
        libraryController.getData({})
    }, []);
    useEffect(() => {
        let searchValue = { ...Object.fromEntries(searchParams.entries()) }
        form.setFieldsValue({ ...searchValue })
        if (!!searchValue?.operator2) {
            setAdvancedSearch(true)
        }
        advanced_search_form.setFieldsValue({
            search: [
                {
                    operator: searchValue?.operator,
                    field: searchValue?.field,
                    keyword: searchValue?.keyword,
                },
                {
                    operator: searchValue?.operator2,
                    field: searchValue?.field2,
                    keyword: searchValue?.keyword2,
                },
                {
                    operator: searchValue?.operator3,
                    field: searchValue?.field3,
                    keyword: searchValue?.keyword3,
                },
            ]
        })
    }, [searchParams])
    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [tableSearchParams])
    useEffect(() => {
        if (width <= 430) {
            setShowMode('card')
        }
        else {
            setShowMode('cardPage')
        }
    }, [width])
    useEffect(() => {
        if (showMode === "card") {
            actionRef.current.reloadAndRest()
        }
        else {
            actionRef.current.reload()
        }
    }, [showMode])
    return (
        <div style={styles.searchContainer}>
            <Col span={24}>
                <Row justify="center">
                    <Col xxl={18} xl={18} lg={20} md={24} sm={24} xs={24}>
                        <Form
                            form={form}
                            onValuesChange={() => { }}
                            onFinish={onSubmit}
                            autoComplete="off"
                            initialValues={{
                                type: "0"
                            }}
                        >
                            <Row justify="center" align={"middle"} gutter={[8, 8]}>
                                <Col xxl={3} xl={3} lg={4} md={4} sm={4} xs={8}  >
                                    {/* <Form.Item
                                        name={"type"}

                                    >
                                        <Select
                                            disabled={true}
                                            // value="0"
                                            placeholder="全部"
                                        >

                                            <SelectTrigger placeholder="全部" className="inputBorder">
                                                <SelectValue placeholder="全部" />
                                            </SelectTrigger>
                                            <SelectContent>
                                                <SelectItem value="0">
                                                    <span className="text-nowrap">全部</span>
                                                </SelectItem>
                                                <SelectItem value="1">
                                                    <span className="text-nowrap">館藏</span>
                                                </SelectItem>
                                                <SelectItem value="2">
                                                    <span className="text-nowrap">電子書</span>
                                                </SelectItem>
                                                <SelectItem value="3">
                                                    <span className="text-nowrap">論文</span>
                                                </SelectItem>
                                            </SelectContent>
                                        </Select>
                                    </Form.Item> */}
                                </Col>
                                <Col xxl={15} xl={15} lg={16} md={16} sm={24} xs={22} >
                                    <Form.Item
                                        name={"keyword"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "請輸入",
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder="搜尋館藏"
                                            className="inputBorder"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xxl={6} xl={6} lg={4} md={4} sm={24} xs={24} >
                                    <Row gutter={[8, 16]} justify="center">
                                        <Col>
                                            <Button
                                                type="button"
                                                className=" h-10 px-4 rounded-full"
                                                style={{ fontSize: "1.6em", height: "90%" }}

                                                onClick={() => {
                                                    if (!!advancedSearch) {
                                                        advanced_search_form.submit()
                                                    }
                                                    else {
                                                        form.submit()
                                                    }

                                                }}
                                            >
                                                查詢
                                            </Button>
                                        </Col>
                                        <Col >
                                            <Button
                                                type="button"
                                                className=" h-10 px-4 rounded-full"
                                                style={{ fontSize: "1.6em", height: "90%" }}
                                                onClick={() => {
                                                    setAdvancedSearch((pre) => {
                                                        if (!!pre) {
                                                            advanced_search_form.setFieldsValue({
                                                                search: [
                                                                    {
                                                                        field: "keyword",
                                                                        keyword: null
                                                                    }
                                                                ]
                                                            })
                                                        }

                                                        return !pre
                                                    })

                                                }}
                                            >
                                                {advancedSearch ? "一般查詢" : "進階查詢"}
                                            </Button>
                                        </Col>
                                        <Col span={24}>
                                        </Col>
                                    </Row>

                                </Col>
                            </Row>
                        </Form>
                    </Col>
                    {advancedSearch && <Col span={24}>
                        <Row justify="center">
                            <Col xxl={20} xl={20} lg={20} md={22} sm={24} xs={24}>
                                <AdvancedSearchForm
                                    propsForm={advanced_search_form}
                                    onFormFinish={(formValue) => {
                                        let { search } = formValue
                                        let values = {}
                                        search?.forEach((element, index) => {
                                            if (!!index) {
                                                values[`field${index + 1}`] = element?.field
                                                values[`keyword${index + 1}`] = element?.keyword
                                                values[`operator${index + 1}`] = element?.operator
                                            }
                                            else {
                                                values[`field`] = element?.field
                                                values[`keyword`] = element?.keyword
                                            }
                                        });
                                        setTableSearchParams((pre) => {
                                            return {
                                                ...values,
                                                branchcode_arr: pre?.branchcode_arr,
                                            }
                                        })
                                        // navigate(`${propsNavigateSearchPath}?` + new URLSearchParams(values));
                                    }}
                                />
                            </Col>
                        </Row>
                    </Col>}

                </Row>
            </Col>
            <Row>
                <Col span={24}>
                    <Row gutter={[16, 16]}>
                        <Col xxl={4} xl={4} lg={4} md={8} sm={8} xs={24}>
                            <Accordion defaultValue={width <= 430 ? null : "show"} type="single" collapsible>
                                <AccordionItem value={"show"}>
                                    <AccordionTrigger><p style={{ fontSize: '25px', fontWeight: 'bold', paddingTop: '15px', paddingBottom: '10px' }}>好書推薦</p></AccordionTrigger>
                                    <AccordionContent>
                                        <Row>
                                            <Col span={24}>
                                                {/* 館藏區選擇 */}
                                                <div style={styles.sectionTitle}>館藏區（暫無篩選功能）</div>
                                                <div style={styles.buttonGroup}>
                                                    {
                                                        libraryController.ResponseData.map((value) => {
                                                            return <Button
                                                                style={tableSearchParams?.branchcode_arr.includes(value?.branchcode) ? styles.activeButton : styles.inactiveButton}
                                                                onClick={() => handleCollectionClick(value?.branchcode)}
                                                            >
                                                                {value?.branchname}
                                                            </Button>
                                                        })
                                                    }
                                                </div>

                                                {/* 藏書種類選擇 */}
                                                <div style={styles.sectionTitle}>藏書種類（暫無篩選功能）</div>
                                                <div style={styles.buttonGroup}>
                                                    <Button
                                                        style={selectedBookType === '期刊' ? styles.activeButton : styles.inactiveButton}
                                                        onClick={() => handleBookTypeClick('期刊')}
                                                    >
                                                        期刊
                                                    </Button>
                                                    <Button
                                                        style={selectedBookType === '電子書' ? styles.activeButton : styles.inactiveButton}
                                                        onClick={() => handleBookTypeClick('電子書')}
                                                    >
                                                        電子書
                                                    </Button>
                                                    <Button
                                                        style={selectedBookType === '西文書' ? styles.activeButton : styles.inactiveButton}
                                                        onClick={() => handleBookTypeClick('西文書')}
                                                    >
                                                        西文書
                                                    </Button>
                                                </div>

                                                {/* 出版年選擇 */}
                                                <div style={styles.sectionTitle}>出版年 （暫無篩選功能）</div>
                                                <div style={styles.buttonGroup}>
                                                    <Button
                                                        style={selectedYear === '2022' ? styles.activeButton : styles.inactiveButton}
                                                        onClick={() => handleYearClick('2022')}
                                                    >
                                                        2022
                                                    </Button>
                                                    <Button
                                                        style={selectedYear === '2023' ? styles.activeButton : styles.inactiveButton}
                                                        onClick={() => handleYearClick('2023')}
                                                    >
                                                        2023
                                                    </Button>
                                                    <Button
                                                        style={selectedYear === '2024' ? styles.activeButton : styles.inactiveButton}
                                                        onClick={() => handleYearClick('2024')}
                                                    >
                                                        2024
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </AccordionContent>
                                </AccordionItem>
                            </Accordion>
                        </Col>

                        <Col xxl={20} xl={20} lg={20} md={16} sm={16} xs={24}>
                            <Row>
                                <Col span={24}>
                                    <Tabs 
                                    items={[
                                        {
                                            key:"cardPage",
                                            tab:"圖文顯示"
                                        },
                                        {
                                            key:"page",
                                            tab:"條列顯示"
                                        },
                                        
                                    ]}
                                    onChange={(val)=>{
                                        setShowMode(val)
                                    }}>

                                    </Tabs>
                                </Col>
                                <Col span={24}>
                                    <ProTableOt
                                        searchParams={tableSearchParams}
                                        showSearch={false}
                                        reloadButton={false}
                                        manageColumnsButton={false}
                                        rowKey={"tag_id"}
                                        actionRef={actionRef}
                                        columns={columns}
                                        check={check}
                                        setCheck={setCheck}
                                        request={async (params = {}, sort, filter) => {
                                            // setAxiosMethod("get")
                                            let newParams = {};
                                            let order = setOrders(sort);
                                            let defaultDate = {
                                                datecreated_start: '1900-01-01',
                                                datecreated_end: dayjs().endOf('year').format('YYYY-MM-DD'),
                                            }
                                            let newTableSearchParams = { ...tableSearchParams }
                                            if (!tableSearchParams?.keyword) {
                                                newTableSearchParams = {
                                                    ...defaultDate
                                                }
                                            }
                                            newParams = {
                                                ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                                ...newParams,
                                                order,
                                                size: params.pageSize,
                                                cur_page: params.current,
                                                // custom_filter_value: params.keyword ?? "",
                                                // custom_filter_key: custom_filter_key,
                                                // ...tableSearchParams
                                                ...newTableSearchParams
                                            };
                                            newParams = setParamsFilter({
                                                ...newParams,
                                            });
                                            return bibController.getData({
                                                ...newParams,
                                            });
                                        }}

                                        rowSelection={false}
                                        manage_columns={true}
                                        showMode={showMode} // page || infiniteScroll || card,
                                        cardRender={(record) => {
                                            return (
                                                <Card style={styles.cardStyle}>
                                                    <Row gutter={[16, 16]}>
                                                        <Col xxl={4} xl={4} lg={5} md={8} sm={10} xs={24}   >
                                                            <Row justify={"center"}>
                                                                <Col xxl={24} xl={24} lg={24} md={24} sm={16} xs={12} >
                                                                    <AspectRatio ratio={3 / 4}>
                                                                        <img
                                                                            src={"https://media.taaze.tw/showLargeImageByIsbn.ashx?height=100%&isbn=" +
                                                                                record?.bibitem_isbn} className=" h-full w-full rounded-md object-cover" />
                                                                    </AspectRatio>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col xxl={20} xl={20} lg={19} md={16} sm={14} xs={24}>
                                                            <Row gutter={[16, 16]}>
                                                                <Col span={24}>
                                                                    {getBibInfoFormat().map((val) => {
                                                                        if (val?.language_name === "bib_title") {
                                                                            return (
                                                                                <Typography.Title level={3}>
                                                                                    {val?.valueKeys.map((keysValue) => record?.[keysValue])}
                                                                                </Typography.Title>
                                                                            )
                                                                        }
                                                                        else if (val?.language_name === "Language") {
                                                                            return (
                                                                                <Col span={24}>
                                                                                    <Typography.P>{t(`${val?.language_name}`)}: {val?.valueKeys.map((keysValue) => record?.[keysValue]?.['Language'])} </Typography.P>
                                                                                </Col>
                                                                            )
                                                                        }
                                                                        else {
                                                                            return <Col span={24}>
                                                                                <Typography.P>{t(`${val?.language_name}`)}:
                                                                                    {val?.valueKeys.map((keysValue) => {
                                                                                        if (val?.isJoin) {
                                                                                            return record?.[keysValue]?.join('、')
                                                                                        }
                                                                                        else {
                                                                                            return record?.[keysValue]
                                                                                        }
                                                                                    })}
                                                                                </Typography.P>
                                                                            </Col>
                                                                        }

                                                                    })}
                                                                    <Col span={24}>
                                                                        <Typography.P>館藏量:
                                                                            {record?.items_count || 0}
                                                                        </Typography.P>
                                                                    </Col>
                                                                </Col>
                                                                <Col span={24} style={{ textAlign: 'right' }}>
                                                                    <Button
                                                                        // style={styles.informationButton}
                                                                        onClick={() => {
                                                                            window.open(propsNavigateCollectionSearchPath + `?biblionumber=${record?.bib_biblionumber}`, 'blank')
                                                                        }}
                                                                    >
                                                                        館藏資訊
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            )
                                        }}
                                        cardModeSetting={{
                                            columnsCount: 1,
                                            singleRowHeight: 100,
                                        }}
                                    />
                                </Col>
                            </Row>

                        </Col>
                    </Row>

                </Col>
            </Row>
        </div>
    );
}

export default SearchFunction;
